module.exports = __webpack_public_path__ + "static/supporters_center_icon2@2x-103a00dafcbba586e2b7250fc048eccb.png";